import dayjs from 'dayjs';
import MonthCalendar from './MonthCalendar';
// import './index.scss';
import Header from './Header';
import React, { useState } from 'react';
import cs from 'classnames';
import LocaleContext from './LocaleContext';
function Calendar(props) {
    const { value, style, className, locale, onChange } = props;
    const [curValue, setCurValue] = useState(value);
    const [curMonth, setCurMonth] = useState(value);
    const classNames = cs("calendar", className);
    function selectHandler(date) {
        setCurValue(date);
        setCurMonth(date);
        onChange === null || onChange === void 0 ? void 0 : onChange(date);
    }
    function prevMonthHandler() {
        setCurMonth(curMonth.subtract(1, 'month'));
    }
    function nextMonthHandler() {
        setCurMonth(curMonth.add(1, 'month'));
    }
    function todayHandler() {
        const date = dayjs(Date.now());
        setCurValue(date);
        setCurMonth(date);
        onChange === null || onChange === void 0 ? void 0 : onChange(date);
    }
    return React.createElement(LocaleContext.Provider, { value: {
            locale: locale || navigator.language
        } },
        React.createElement("div", { className: classNames, style: style },
            React.createElement(Header, { curMonth: curMonth, prevMonthHandler: prevMonthHandler, nextMonthHandler: nextMonthHandler, todayHandler: todayHandler }),
            React.createElement(MonthCalendar, Object.assign({}, props, { value: curValue, curMonth: curMonth, selectHandler: selectHandler }))));
}
export default Calendar;
